import request from "@/config/serve.js";
import recursionServe from "@/config/recursionServe.js";

// 查询
export function getCpsReportList(params) {
  return request("post", "/apiGo/api/v1/cpsreport/list", {
    deleted: false,
    ...params,
  });
}

// 递归查询
export function getCpsReportListRecursion(params, callback) {
  return recursionServe(callback, "post", "/apiGo/api/v1/cpsreport/list", {
    deleted: false,
    ...params,
  });
}

export function getCpsReportStatistics(params) {
  return request("post", "/apiGo/api/v1/cpsreport/statistics", {
    deleted: false,
    ...params,
  });
}
